import { ComingSoonPage } from "../../components";

const Arbitrage = () => {
    return (
        <ComingSoonPage />
    )
}

export default Arbitrage;